var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionArticleCourseLessonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 43,
    viewBox: "0 0 34 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7939 13.9953C33.6931 13.7646 33.5521 13.5538 33.3774 13.3726L20.6274 0.622625C20.4462 0.447912 20.2354 0.306874 20.0047 0.206125C19.941 0.176375 19.873 0.159375 19.805 0.136C19.6272 0.0754931 19.4421 0.0390451 19.2546 0.027625C19.21 0.023375 19.1696 0 19.125 0H4.25C1.90612 0 0 1.90612 0 4.25V38.25C0 40.5939 1.90612 42.5 4.25 42.5H29.75C32.0939 42.5 34 40.5939 34 38.25V14.875C34 14.8304 33.9766 14.79 33.9724 14.7432C33.962 14.5556 33.9255 14.3704 33.864 14.1929C33.8428 14.1249 33.8236 14.059 33.7939 13.9953ZM26.7453 12.75H21.25V7.25475L26.7453 12.75ZM4.25 38.25V4.25H17V14.875C17 15.4386 17.2239 15.9791 17.6224 16.3776C18.0209 16.7761 18.5614 17 19.125 17H29.75L29.7543 38.25H4.25Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 21.25H25.5V25.5H8.5V21.25ZM8.5 29.75H25.5V34H8.5V29.75ZM8.5 12.75H12.75V17H8.5V12.75Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionArticleCourseLessonIcon);
export default __webpack_public_path__ + "static/media/option_article_course_lesson_icon.65034edd922b50805bb644b68f0d31d0.svg";
export { ForwardRef as ReactComponent };